import { render, staticRenderFns } from "./FormControlDangerValidationHelperText.vue?vue&type=template&id=5ad6bc2f"
import script from "./FormControlDangerValidationHelperText.vue?vue&type=script&lang=js"
export * from "./FormControlDangerValidationHelperText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports